import React, { useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import './css/Home.css';
import MobileReviewDeck from './MobileReviewDeck.jsx';
import BannerImage from './BannerImage.jsx';

import { getProducts } from '../lib/productData.js';
const INITIAL_PRODUCTS = getProducts();

const Home = () => {
  const navigate = useNavigate();

  const [openFaqIndex, setOpenFaqIndex] = useState(0);

  const toggleFaq = (index) => {
    setOpenFaqIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  // ── INLINE ON-RELOAD RANDOM PRODUCT SELECTION ──
  // The empty dependency matrix [] guarantees this executes ONCE when the app mounts.
  const randomProducts = useMemo(() => {
    if (!INITIAL_PRODUCTS || INITIAL_PRODUCTS.length === 0) return [];
    return [...INITIAL_PRODUCTS]
      .sort(() => 0.5 - Math.random())
      .slice(0, 5);
  }, []);

  const REVIEWS = [
    {
      id: 4,
      name: "Sanjay Malhotra",
      role: "Quality Assurance Head, Deccan Logistics",
      stars: 5,
      text: "Testing their brake cam and lever sets under high-stress cycles proved their durability. Excellent mechanical return response and no micro-fracturing under load.",
      featured: false
    },
    {
      id: 5,
      name: "Amit Sharma",
      role: "Custom Chassis Builder",
      stars: 5,
      text: "The precision on the beeding and fairing screws is top-tier. Clean thread pitch and smooth engagement that prevents strip-outs during rapid panel mockups.",
      featured: true
    },
    {
      id: 6,
      name: "Rohan Joshi",
      role: "Distributor, Apex Auto Spares",
      stars: 5,
      text: "Our retail network heavily relies on Walnut's metric steel washers and general fastener kits. The consistency in zinc-plating quality keeps our dealers coming back.",
      featured: false
    }
  ];

  const faqData = [
    { q: "How can I track my order?", a: "Log in to your account and go to the 'Track Order' section. Click on your order to see its current status, estimated delivery date, and courier tracking details." },
    { q: "What payment methods do you accept?", a: "We accept UPI, Net Banking, Credit/Debit Cards (Visa, Mastercard), and Cash on Delivery (COD) for eligible orders above ₹200." },
    { q: "How do I return a product?", a: "Initiate a return within 7 days of delivery via your account dashboard. Products must be unused and in original packaging. Our team will arrange a pickup." },
    { q: "What should I do if I receive a damaged product?", a: "Take photos of the damaged product and packaging immediately upon receipt. Contact our support team within 48 hours and we'll arrange a free replacement or full refund." },
    { q: "How do I contact customer support?", a: "You can reach us via the Contact Us page, email at support@walnut.in, or call our helpline Mon–Sat 9 AM to 6 PM IST." },
  ];

  return (
    <div>

      {/* ── RESPONSIVE IMAGE HERO BANNER ── */}
      <section 
        className="products-hero-banner" 
        style={{ 
          width: '100%', 
          backgroundColor: '#0E0E0E', 
          overflow: 'hidden',
          /* If your navbar is fixed/absolute, uncomment the line below and change 80px to match your navbar height */
          // marginTop: '80px', 
        }}
      >
        {/* Full-width responsive banner graphic */}
        <BannerImage
          src="/banners/HOME PAGE WALNUT.png"
          alt="Walnut Industries Fasteners Catalog Showcase"
          style={{ width: '100%' }}
          imageStyle={{ height: 'auto' }}
          fallbackText="Home Banner"
        />
      </section>

      {/* TRUST BAR */}
<div className="trust-bar">
  <div className="trust-item">
    <div className="t-icon">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" width="22" height="22">
        <path d="M12 2L3 7v5c0 5.25 3.75 10.15 9 11.25C17.25 22.15 21 17.25 21 12V7L12 2z"/>
        <path d="M9 12l2 2 4-4"/>
      </svg>
    </div>
    <div>
      <div className="t-title">High Grade Material</div>
      <div className="t-sub">Industrial standard certified</div>
    </div>
  </div>

  <div className="trust-item">
    <div className="t-icon">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" width="22" height="22">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
        <path d="M12 8v4M12 16h.01"/>
      </svg>
    </div>
    <div>
      <div className="t-title">Corrosion Resistant</div>
      <div className="t-sub">Built to last longer</div>
    </div>
  </div>

  <div className="trust-item">
    <div className="t-icon">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" width="22" height="22">
        <path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/>
        <path d="M3.27 6.96L12 12.01l8.73-5.05M12 22.08V12"/>
      </svg>
    </div>
    <div>
      <div className="t-title">Wide Range of Products</div>
      <div className="t-sub">5000+ SKUs available</div>
    </div>
  </div>

  <div className="trust-item">
    <div className="t-icon">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" width="22" height="22">
        <rect x="1" y="3" width="15" height="13" rx="1"/>
        <path d="M16 8h4l3 3v5h-7V8z"/>
        <circle cx="5.5" cy="18.5" r="2.5"/>
        <circle cx="18.5" cy="18.5" r="2.5"/>
      </svg>
    </div>
    <div>
      <div className="t-title">Fast & Reliable Delivery</div>
      <div className="t-sub">Pan India shipping</div>
    </div>
  </div>
</div>

      {/* RECOMMENDED (FEATURED SPOTLIGHTS) */}
      <div className="section-header"><h2>Recommended</h2></div>
      <section className="recommended">
        <div className="products-grid">
          {randomProducts.map((product) => (
            <div className="product-card" key={product.id}>
              <div className="product-img" style={{ position: 'relative', overflow: 'hidden' }}>
                {product.badge && <span className="product-ribbon-badge" style={{ position: 'absolute', top: '10px', left: '10px', backgroundColor: 'var(--red, #D0021B)', color: '#fff', padding: '2px 8px', fontSize: '10px', fontWeight: '700', borderRadius: '4px', zIndex: 2 }}>{product.badge}</span>}
                
                {/* Dynamic Product Thumbnail Image Pipeline */}
                <img 
                  src={`/resources/${product.image}`} 
                  alt={product.name} 
                  style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                  onError={(e) => {
                    // Fallback to layout placeholder if local resource asset is missing
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'flex';
                  }}
                />

                {/* Vector Wireframe Fallback Structure */}
                <div className="img-placeholder" style={{ display: 'none', height: '100%', width: '100%', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" width="40" height="40">
                    <rect x="3" y="3" width="18" height="18" rx="2" />
                    <path d="M3 9h18M9 21V9" />
                  </svg>
                </div>
              </div>
              <div className="product-info">
                <div className="product-name" style={{ fontWeight: '600', fontSize: '16px' }}>{product.name}</div>
                <div className="product-meta-sub" style={{ fontSize: '12px', color: '#666', margin: '4px 0 12px', lineHeight: '1.3' }}>{product.meta}</div>
                <div className="btn-small" onClick={() => navigate("/contact")} style={{ cursor: 'pointer' }}>Inquire Specs</div>
              </div>
            </div>
          ))}
        </div>
      </section>

     {/* PRODUCT CATEGORY */}
<section className="category-section">
  <div className="section-header"><h2>Product Category</h2></div>
  <div className="responsive-home">

    {/* Top Primary Grid — 2 Categories Only */}
    <div className="category-grid-top">
      {[
        { name: "Automotive Fasteners", image: "/resources/category/Brake Drum Plate Nut Bolt Washer.png" },
        { name: "Two Wheeler Spares", image: "/resources/category/Brake Cam & Lever Set.png" },
      ].map((cat, idx) => (
        <div
          className="cat-card"
          key={idx}
          style={{ cursor: 'pointer' }}
          onClick={() => navigate('/products')}
        >
          <div className="cat-img">
            <img
              src={cat.image}
              alt={cat.name}
              style={{ width: '100%', height: '100%', objectFit: 'cover', padding: '15px' }}
            />
          </div>
          <p style={{ marginTop: '12px', fontWeight: '600' }}>{cat.name}</p>
        </div>
      ))}
    </div>
  </div>
</section>

     {/* EXPLORE / FACTORY */}
<section className="explore-section">
  <div className="explore-content">
    <div className="explore-label">Our Manufacturing</div>
    <h2>EXPLORE<br />WALNUT<br />FACTORY</h2>
    <p>From precision CNC machining to rigorous quality control, every Walnut part is engineered to meet international standards. Our state-of-the-art facility ensures consistency, durability, and performance in every single component we manufacture.</p>
    <button className="btn-red">Get Quote</button>
  </div>
  <div className="explore-img">
    <img
      src="/resources/walnut-factory.png"
      alt="Walnut Factory"
      style={{
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        display: 'block',
      }}
      onError={(e) => { e.target.style.display = 'none'; }}
    />
  </div>
</section>

     {/* ── CUSTOMER REVIEWS ── */}
<section className="client-endorsements-section">
  <div className="centered-section-heading">
    <h2>CUSTOMER REVIEW</h2>
  </div>

  {/* Desktop — tilted stack (existing) */}
  <div className="endorsements-cards-container desktop-reviews">
    {REVIEWS.slice(0, 3).map((review, idx) => {
      let positionClass = "card-center";
      if (idx === 0) positionClass = "card-left";
      if (idx === 2) positionClass = "card-right";
      return (
        <div
          className={`endorsement-card-v2 ${positionClass} ${review.featured ? 'highlighted' : ''}`}
          key={review.id}
        >
          <div className="avatar-circle-container">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#666" strokeWidth="1.5">
              <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
              <circle cx="8.5" cy="8.5" r="1.5" />
              <polyline points="21 15 16 10 5 21" />
            </svg>
          </div>
          <h3 className="endorser-identity-v2">{review.name}</h3>
          <div className="star-rating-row-v2">{"★".repeat(review.stars)}</div>
          <p className="endorsement-quote-text-v2">"{review.text}"</p>
        </div>
      );
    })}
  </div>

  {/* Mobile — tap through card deck */}
  <MobileReviewDeck reviews={REVIEWS.slice(0, 3)} />

</section>

     {/* FEATURES */}
<section className="features-section">
  <div className="section-header"><h2>Features</h2></div>
  <div style={{ padding: '0 40px 20px' }}>
    <div className="features-grid">

      <div className="feature-item">
        <div className="feature-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" width="28" height="28">
            <circle cx="12" cy="12" r="3"/>
            <path d="M12 2v3M12 19v3M4.22 4.22l2.12 2.12M17.66 17.66l2.12 2.12M2 12h3M19 12h3M4.22 19.78l2.12-2.12M17.66 6.34l2.12-2.12"/>
          </svg>
        </div>
        <div className="feature-title">Precision Manufacturing</div>
      </div>

      <div className="feature-item">
        <div className="feature-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" width="28" height="28">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
          </svg>
        </div>
        <div className="feature-title">Premium Quality</div>
      </div>

      <div className="feature-item">
        <div className="feature-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" width="28" height="28">
            <circle cx="12" cy="8" r="6"/>
            <path d="M8.21 13.89L7 23l5-3 5 3-1.21-9.12"/>
          </svg>
        </div>
        <div className="feature-title">46+ Years Experience</div>
      </div>

      <div className="feature-item">
        <div className="feature-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" width="28" height="28">
            <circle cx="12" cy="12" r="10"/>
            <path d="M2 12h20M12 2a15.3 15.3 0 010 20M12 2a15.3 15.3 0 000 20"/>
          </svg>
        </div>
        <div className="feature-title">Worldwide Export</div>
      </div>

    </div>
  </div>
</section>

      {/* BRANDS */}
<section className="brands-section">
  <div className="section-header" style={{ paddingTop: '50px' }}><h2>Brands</h2></div>
  <div style={{ padding: '0 40px 20px' }}>
    <div className="brands-grid">
      {[
        {
          name: "Hero MotoCorp",
          image: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0f/Hero_MotoCorp.svg/1280px-Hero_MotoCorp.svg.png",
        },
        {
          name: "Bajaj Auto",
          image: "https://1000logos.net/wp-content/uploads/2020/07/Bajaj-logo.jpg",
        },
        {
          name: "TVS Motor",
          image: "https://onlykutts.com/wp-content/uploads/2022/08/TVS-new-logo.jpeg",
        },
        {
          name: "Honda",
          image: "https://upload.wikimedia.org/wikipedia/commons/7/7b/Honda_Logo.svg",
        },
        {
          name: "Royal Enfield",
          image: "https://images.seeklogo.com/logo-png/36/1/royal-enfield-logo-png_seeklogo-361484.png",
        },
        {
          name: "Yamaha",
          image: "https://img2.clipart-library.com/26/yamaha-logo-clipart/yamaha-logo-clipart-3.webp",
        },
      ].map((brand, idx) => (
        <div className="brand-card" key={idx}>
          <img
            src={brand.image}
            alt={brand.name}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
              padding: '12px',
              filter: 'grayscale(100%)',
              transition: 'filter 0.3s',
            }}
            onMouseEnter={e => e.currentTarget.style.filter = 'grayscale(0%)'}
            onMouseLeave={e => e.currentTarget.style.filter = 'grayscale(100%)'}
          />
        </div>
      ))}
    </div>
  </div>
</section>

      {/* FAQ */}
      <div style={{ maxWidth: '860px', margin: '0 auto' }}>
        <div className="section-header"><h2>FAQ</h2></div>
      </div>
      <section className="faq-section" style={{ paddingTop: '10px' }}>
        {faqData.map((item, idx) => {
          const isOpen = openFaqIndex === idx;
          return (
            <div className={`faq-item ${isOpen ? 'open' : ''}`} key={idx}>
              <div className="faq-q" onClick={() => toggleFaq(idx)}>
                <span><span className="faq-num">{idx + 1}.</span> {item.q}</span>
                <div className="faq-icon">{isOpen ? '−' : '+'}</div>
              </div>
              <div className="faq-a">{item.a}</div>
            </div>
          );
        })}
      </section>

    </div>
  );
};

export default Home;